<script setup>
  const { small } = defineProps({ small: Boolean });
</script>

<!----------------------------------------------------------------------------->

<template>
  <Section :class="{ small }" autowrap :wide="!small">
    <GridItem class="wrapper">
      <ShowAnimation fadeOnly
        ><h1><slot /></h1
      ></ShowAnimation>
    </GridItem>
  </Section>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  section {
    @include top-padding;
    padding-bottom: $block-padding-extra-large;

    @include break-min-large {
      h1 {
        max-width: 72vw;
      }
    }

    @include break-medium {
      padding-bottom: 6vw;
    }

    @include break-small {
      padding-bottom: $block-padding-medium;
    }

    @include break-phone {
      padding-bottom: $block-padding-extra-small;
    }

    &.small {
      padding-bottom: px(10);

      .wrapper {
        @include column(2, 9);
      }

      @include break-medium {
        padding-bottom: 0;
        .wrapper {
          @include column(2, 10);
        }
      }

      @include break-small {
        .wrapper {
          @include column(2, 11);
        }
      }

      @include break-phone {
        padding-bottom: px(18);
      }

      h1 {
        @include title-l;
      }
    }
  }
</style>
